import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ExpandModifierOptions = (props: SvgProps) => (
  <Svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 7.83871V3.96774M11 4.74194V7.06452M1 3V9M11 3V9"
      stroke="#475569"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16129 1H8.03226M7.25806 11H4.93548M9 1H3M9 11H3"
      stroke="#1E293B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default ExpandModifierOptions;
